import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import React from "react";
import { SecuredMenuFunctionalButton } from "../../Buttons/SecuredMenuFunctionalButton";
import { FileCopy } from "@material-ui/icons";
import SaveIcon from "@material-ui/icons/SaveAlt";
import { inject } from "mobx-react";
import { SecuredMenuLinkButton } from "../../../index";
import { SecuredEditButton } from "../../Buttons/SecuredEditButton";

export interface DefaultRowButtonsConfig {
  edit: boolean;
  delete: boolean;
  copy: boolean;
  export: boolean;
}

const Button = inject("i18n")(({ i18n: i18n, title: titleArgs, ...props }) => {
  const title = i18n.t(...titleArgs);
  return (
    <>
      {props.link ? (
        <SecuredMenuLinkButton title={title} {...props} />
      ) : (
        <SecuredMenuFunctionalButton title={title} {...props} />
      )}
    </>
  );
});

const EditButton = inject("i18n")(({ i18n: i18n, ...props }) => {
  return <SecuredEditButton {...props} />;
});

export const defaultRowButtons = (
  indexProps: any,
  config: DefaultRowButtonsConfig = {
    edit: true,
    delete: true,
    copy: true,
    export: false
  }
) => (row: any, key: string, close: () => void) => {
  const arr = [];
  const urlPrefix = indexProps.props.baseUrl || "";
  const onDelete = (e: any) => {
    indexProps.callbackDelete(row);
    close();
  };

  const onExport = (e: any) => {
    indexProps.props.dataSource.exportSelected("text/csv", row);
    close();
  };

  if (config.edit) {
    arr.push(
      <EditButton
        link={urlPrefix + indexProps.props.columns.link(row)}
        key={key + "edit"}
      />
    );
  }

  if (config.copy) {
    arr.push(
      <Button
        link={urlPrefix + "/create" + indexProps.props.columns.link(row)}
        title={["lego:views.index.row.copy", "Copy"]}
        requiredAccess={"editable"}
        key={key + "copy"}
      >
        <FileCopy />
      </Button>
    );
  }

  if (config.delete) {
    arr.push(
      <Button
        callbackFunction={onDelete}
        title={["lego:views.index.row.delete", "Delete"]}
        key={key + "delete"}
      >
        <DeleteIcon />
      </Button>
    );
  }

  if (config.export) {
    arr.push(
      <Button
        callbackFunction={onExport}
        title={["lego:views.index.row.export", "Export"]}
        key={key + "export"}
      >
        <SaveIcon />
      </Button>
    );
  }

  return arr;
};

export const defaultRowButtonsCreator = (config: DefaultRowButtonsConfig) => {
  return (props: any) => defaultRowButtons(props, config);
};
